import { Upload, Form, Input, Radio, Row, UploadProps, Flex } from "antd";
import styles from "./index.module.less";
import { useEffect, useState } from "react";
import modalCloseIcon from "@/assets/imgs/modal_close.svg";
import classNames from "classnames";
import message from "@/plugins/message";
import SVGIcon from "../SVGIcon";
import EmailIcon from "./mail.svg?react";
import { isMobile } from "@/utils";
import MobileEmailModal from "./mobile";

const { Dragger } = Upload;
const EmailModal = ({
  visible,
  title,
  onClose,
}: {
  visible: boolean;
  title?: string;
  onClose?: () => void;
}) => {
  if (!visible) {
    return null;
  }
  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };

  const [closing, setClosing] = useState(false);
const handleCopyEmail = () => {
    navigator.clipboard.writeText("jobs@xiaoice.cn");
    message.success("复制成功");
}
  return (
    <div className={styles.EmailModal}>
      <div
        className={classNames(styles.mask, {
          [styles.fadeOut]: closing,
          [styles.fadeIn]: !closing,
        })}
      ></div>
      <div
        className={classNames(styles.body, {
          [styles.fadeOut]: closing,
          [styles.fadeIn]: !closing,
        })}
      >
        <div className={styles.header}>
          <div className={styles.title}>{title || "投递简历"}</div>
          <div className={styles.close} onClick={handleClose}>
            <img src={modalCloseIcon} />
          </div>
        </div>
        <Flex align="center" vertical className={styles.content}>
            <SVGIcon width={64} icon={<EmailIcon/>}/>
            <div>将你的简历邮箱发送到邮箱</div>
            <div>jobs@xiaoice.cn</div>
        </Flex>
        <div className={styles.footer}>
          <div className={styles.submitBtn} onClick={handleCopyEmail}>
            复制邮箱
          </div>
        </div>
      </div>
    </div>
  );
};

export default isMobile() ? MobileEmailModal : EmailModal;
